var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_vm.isEditable ? _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('OmniButton', {
    attrs: {
      "disabled": _vm.isSaving,
      "isProcessing": _vm.isSaving,
      "icon": "save",
      "size": "lg",
      "type": "submit",
      "variant": "success"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")])], 1)]) : _vm._e(), _c('b-card', [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.packaging-management.available-boxes.title')) + " ")]), _c('div', {
    staticClass: "row my-1"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('OmniCheckboxes', {
    key: _vm.allBoxes.length,
    attrs: {
      "draggable": false,
      "grid": false,
      "hideCheckboxes": !_vm.isEditable,
      "options": _vm.allBoxes
    },
    model: {
      value: _vm.selectedBoxes,
      callback: function ($$v) {
        _vm.selectedBoxes = $$v;
      },
      expression: "selectedBoxes"
    }
  })], 1)])], 1), _vm.isEditable ? _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('OmniButton', {
    attrs: {
      "disabled": _vm.isSaving,
      "isProcessing": _vm.isSaving,
      "icon": "save",
      "size": "lg",
      "type": "submit",
      "variant": "success"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")])], 1)]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }